import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    if (data.token) setToken(data.token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    // Étape 1 : crée une inscription en attente + envoie le code (aucun compte créé ici)
    const { data } = await api.post("/auth/register", payload);
    return data;
  };

  const verifyEmail = async (email, code) => {
    // Étape 2 : code correct → compte créé (email_verified=true) + connexion
    const { data } = await api.post("/auth/verify-email", { email, code });
    if (data.token) setToken(data.token);
    setUser(data);
    return data;
  };

  const resendCode = async (email) => {
    const { data } = await api.post("/auth/resend-code", { email });
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, verifyEmail, resendCode, logout, refresh, isAdmin: user && user.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};
